export default __webpack_public_path__ + "static/aqualand-e9764451458615ca99f764f60fe18d54.png";